import { useState } from 'react';

// Note this assumes that when using useLocalStorage, if the value already exists, you want to keep it
export default function useLocalStorage<T>(key: string, starting: T): [T, (val: T) => void] {
  const [value, setValue] = useState<T>(() => {
    try {
      const current = localStorage.getItem(key);
      if (current) {
        return JSON.parse(current) as T;
      } else {
        localStorage.setItem(key, JSON.stringify(starting));
        return starting as T;
      }
    } catch (err) {
      console.log(err);
      return starting as T;
    }
  });

  const setLocalStorage = (val: T) => {
    try {
      localStorage.setItem(key, JSON.stringify(val));
    } catch (err) {
      console.log(err);
    }
    setValue(val);
  };

  return [value, setLocalStorage];
}

// THIS HOOK ISN'T USED ANYWHERE BUT KEPT IN CASE WE NEED IT
